/**
 * Feature flags for gating in-progress or dev-only features.
 *
 * Currently drives route registration in `routes/Router.js`, sidebar
 * menu items in `layouts/full-layout/sidebar/Menuitems.js`, and any
 * dev-only UI components (e.g. DevEventSimulator).
 *
 * Flags that read from `process.env.NODE_ENV` get inlined by webpack
 * at build time, so anything gated with `!FLAGS.foo && ...` is
 * tree-shaken out of the production bundle.
 */

const IS_DEV = process.env.NODE_ENV !== 'production';

const FLAGS = {
  /**
   * Automatizaciones (flow engine). Routes always registered;
   * visibility controlled per-client via features toggle.
   */
  automations: true,

  /**
   * Dev-only utilities (event simulators, debug panels, etc).
   * Always tied to NODE_ENV so they never leak to production.
   */
  devTools: IS_DEV,
};

/**
 * Check whether a client-level feature toggle is enabled.
 *
 * In dev mode all features are enabled regardless of client settings.
 * In production, checks client.features[featureKey] === true.
 *
 * @param {string} featureKey - e.g. 'automations', 'ai_campaigns'
 * @param {object|null} client - client object with optional features dict
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureKey, client) => {
  return client?.features?.[featureKey] === true;
};

export default FLAGS;
